import State from "models/state"
import {connect} from "react-redux"
import {REALM_HEADER} from "@next/utils"
import {ColourwayData} from "../models/searchApi"
import {formatPdpLink, getToolTipTitleByType, formatTitle} from "../utils/colourwayBuilders"
import getTitleUtil from "../utils/getTitleUtil"
import {selectPriceType} from "../utils/priceFormatter/selectPriceType"
import {ProductType} from "../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {
                id: itemNumber,
                type: productType,
                colourways,
                brand,
                baseUrl,
                title: defaultTitle,
                department,
                currencyCode,
                type,
                fit,
            },
            enableBrandDisplay,
            enabledSearchDesc,
            colourwaysHasSale,
            colourwaysHasRating,
            colourwaysHasStarRatingWithRangedPrice,
            enableReviewStars,
            enableSingleLineTitle,
            numberOfAllColourways,
            enableSingleLineBrandName,
            useProductAggregator,
            enableQuickAddToBag,
        },
        request,
        text,
        template,
        textAlignment,
    } = state

    const realm = state.request.headers[REALM_HEADER] as string
    const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData
    const linkUrl = formatPdpLink(baseUrl, selectedColourway.url)
    const getTitle = (
        useProductAggregator
            ? selectedColourway?.t
            : getTitleUtil({
                  enabledSearchDesc,
                  title: defaultTitle,
                  selectedColourway,
                  fit,
                  department,
                  isEnglishLang: request.isEnglishLang,
                  type,
              })
    ) as string
    const textTitle = enabledSearchDesc
        ? selectedColourway?.t || ""
        : formatTitle({
              title: defaultTitle,
              selectedColourway,
              fit,
              department,
              isEnglishLang: request.isEnglishLang,
          })

    return {
        template,
        itemNumber,
        firstItemNumber: colourways[0]?.id,
        productType,
        enableBrandDisplay,
        brand,
        colourwaysHasSale,
        colourwaysHasStarRatingWithRangedPrice,
        linkUrl,
        title: getTitle,
        price: selectPriceType(selectedColourway.p, selectedColourway?.sp),
        colour: selectedColourway.c,
        currencyCode,
        department,
        tooltipTitle: getToolTipTitleByType(type, {
            title: selectedColourway.t,
            defaultTitle: textTitle,
            colourwayItemNumber: selectedColourway.id,
            price: selectedColourway.p,
            salePrice: selectedColourway.sp,
            fit,
            selectedColourway,
            isEnglishLang: request.isEnglishLang,
        }),
        isPriceARange: selectedColourway?.p?.includes("-") || false,
        isWasPriceARange: selectedColourway?.wp?.includes("-") || false,
        colourwaysHasRating,
        overallStarRating: selectedColourway.st || 0,
        ratingText: text.labels.rating,
        enableReviewStars: enableReviewStars ? productType === ProductType : false,
        enableSingleLineTitle,
        numberOfAllColourways,
        enableSingleLineBrandName,
        client: realm,
        enableQuickAddToBag,
        textAlignment,
        colourways,
    }
}

export default connect(mapStateToProps)
